import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import IconButton from "../../../components/buttons/IconButton";
import { CurrencyInput, PercentageInput } from "../../../components/forms";
import { patchReplace } from "../../../helpers/patchDoc";
import { useFetchInvestTransactionsQuery } from "../../../services/recommendations";
import SedolSearch from "./SedolSearch";

const InvestTransaction = ({
    investId,
    index,
    isLoading,
    isCreating,
    isDeleting,
    realtimeItem,
    maxAllocation,
    totalMinusFees,
    addRow,
    deleteRow,
    updateRealTime,
    patchTransaction
}) => {

    const { item } = useFetchInvestTransactionsQuery({ investId }, {
        selectFromResult: ({ data }) => {
            return { item: data[index] }
        }
    });

    const [displayAllocation, setDisplayAllocation] = useState(null);

    useEffect(() => {
        setDisplayAllocation(item?.allocation);
    }, [item?.allocation]);

    useEffect(() => {
        if (index === 0 || displayAllocation == null)
            setDisplayAllocation(realtimeItem?.allocation);
    }, [displayAllocation, index, realtimeItem?.allocation]);

    return <>
        <SedolSearch
            realTimeSedol={realtimeItem?.sedol ?? ""}
            sedol={item?.sedol ?? ""}
            realTimeAssetName={realtimeItem?.assetName ?? ""}
            patchRealTime={(operations) => updateRealTime(operations, index)}
            patchService={(operations) => patchTransaction(operations, index)}
            isLoading={isLoading}
        />
        {isLoading
            ? <Skeleton />
            : <PercentageInput
                value={displayAllocation}
                onChange={(_, { floatValue }) => {
                    setDisplayAllocation(floatValue ?? 0);

                    let calculationValue = Math.min(floatValue ?? 0, maxAllocation);

                    const newValue = calculationValue * totalMinusFees / 100;
                    const operations = [
                        patchReplace("allocation", calculationValue),
                        patchReplace("investmentAmount", newValue)
                    ];

                    return updateRealTime(operations, index);
                }}
                onBlur={(amount) => {
                    let calculationValue = Math.min(amount ?? 0, maxAllocation);
                    setDisplayAllocation(calculationValue);

                    const newValue = calculationValue * totalMinusFees / 100;
                    const operations = [
                        patchReplace("allocation", calculationValue),
                        patchReplace("investmentAmount", newValue)
                    ];

                    return patchTransaction(operations, index);
                }}
                disableAnimations={item?.allocation === maxAllocation && displayAllocation >= maxAllocation}
                readOnly={(item?.rowTag ?? 0) === 0}
            />}

        {isLoading
            ? <Skeleton />
            : <CurrencyInput value={realtimeItem?.investmentAmount} readOnly />}

        {item?.rowTag === 0
            ? <IconButton
                icon={"circle-plus"}
                variant={"success"}
                disabled={isCreating}
                onClick={() => addRow()}
            />
            : <IconButton
                icon={"fa-trash"}
                variant={"danger"}
                disabled={isCreating || isDeleting}
                onClick={() => deleteRow(item?.rowTag)}
            />}
    </>;
}

export default InvestTransaction;
